import { useMutation } from '@tanstack/react-query';
import { authFetch } from '../utils/authFetch';
import { API_URL } from '../config/api';


const setPlaidAccessToken = async (publicToken: string) => {
  const response = await authFetch(
    `${API_URL}/integrations/plaid/set-access-token`, {
    method: 'POST',
    body: JSON.stringify({ public_token: publicToken }),
  });
  if (!response.ok) {
    throw new Error('Failed to set Plaid access token');
  }
  return response.json();
};

export const useSetPlaidAccessToken = () => {
  return useMutation({
    mutationFn: setPlaidAccessToken,
  });
};